export default {
  // Common
  common: {
    loading: 'Loading...',
    loadingData: 'Loading data...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    filter: 'Filter',
    clearFilters: 'Clear filters',
    clear: 'Clear',
    all: 'All',
    none: 'None',
    yes: 'Yes',
    no: 'No',
    actions: 'Actions',
    details: 'Details',
    download: 'Download',
    downloadPDF: 'Download PDF',
    viewDetails: 'View details',
    noData: 'No data',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    date: 'Date'
  },

  // DataTable common
  dataTable: {
    sortBy: 'Sort by',
    sortAsc: 'Ascending',
    sortDesc: 'Descending',
    filters: 'Filters',
    applyFilters: 'Apply filters',
    clearFilters: 'Clear filters'
  },

  // Navigation
  nav: {
    home: 'Home',
    invoices: 'Invoices',
    issues: 'Issues',
    generation: 'Generation',
    data: 'Data',
    customers: 'Customers',
    contracts: 'Contracts',
    consumptionPoints: 'Consumption Points',
    myAccount: 'My Account',
    profile: 'Profile',
    linkAccount: 'Link Account',
    logout: 'Logout',
    backToSite: 'Back',
    operatorManagement: 'Operator Management',
    impersonate: 'Impersonation',
    menu: 'Menu',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    help: 'User Manual'
  },

  // Footer
  footer: {
    help: 'User Manual',
    terms: 'EPK Terms of Service',
    privacy: 'Privacy Policy',
    support: 'Portal issue',
    supportSubject: 'EPK Portal — technical issue',
    securedBy: 'Secure payments by',
    autopayAlt: 'Autopay'
  },

  // Help / User manual
  help: {
    tocLabel: 'Table of contents',
    translationPending: 'Translation in progress — showing Polish version.',
    sectionNotFound: 'Section not found.',
    backToHome: 'Back to dashboard',
    backToFirstSection: 'Back to the first section',
    loadFailed: 'Failed to load the manual.'
  },

  // Auth
  auth: {
    login: 'Login',
    logout: 'Logout',
    register: {
      subtitle: 'Register to access your energy portal.',
      firstNamePlaceholder: 'John',
      lastNamePlaceholder: 'Doe',
      phonePlaceholder: '+48 000 000 000',
      phoneHint: '+48 is pre-filled by default — you can change it if your number is from outside Poland. Format: +<country code><digits>',
      phoneFormatError: 'The number must start with „+" and a country code (e.g. +48 for Poland).',
      passwordMinLength: 'Minimum 8 characters',
      passwordMinLengthError: 'Password must be at least 8 characters',
      passwordMismatch: 'Passwords do not match',
      submitButton: 'Register',
      submitting: 'Creating account...',
      failed: 'Registration failed. Please try again.',
      alreadyHaveAccount: 'Already have an account? Login here'
    },
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account? Register here",
    hasAccount: 'Already have an account? Login',
    loggingIn: 'Logging in...',
    registering: 'Registering...',
    loginFailed: 'Login failed. Please try again.',
    registerSuccess: 'Registration successful. Please check your email for verification.',
    welcomeBack: 'Welcome back! Please login to your account.',
    createAccount: 'Create your account in the Electronic Customer Portal',
    passwordReset: 'Password Reset',
    passwordResetRequest: 'Request password reset',
    passwordResetConfirm: 'Confirm new password',
    resetPassword: 'Reset password',
    enterEmail: 'Enter your email address',
    enterNewPassword: 'Enter new password',
    passwordResetSent: 'Password reset link has been sent to your email.',
    passwordResetSuccess: 'Password has been changed. You can now login.',
    invalidResetToken: 'Invalid or expired password reset token.',
    tooManyAttempts: 'Too many login attempts. Please try again in {minutes} min.',
    verifyEmail: {
      title: 'Email Verification',
      verifying: 'Verifying...',
      success: 'Your email address has been successfully verified.',
      alreadyVerified: 'This email has already been verified.',
      error: 'Invalid or expired verification token.',
      noToken: 'No verification token found in the link.',
      goToLogin: 'Go to login'
    },
    resendVerification: {
      description: 'Enter the email address to resend the activation link to.',
      submit: 'Send',
      success: 'Activation link has been sent to the provided email address.'
    },
    emailNotVerified: 'Email address has not been verified. Check your inbox.',
    resendButton: 'Resend activation link',
    alreadyVerified: 'Email already verified. If you forgot your password, use the password reset option.',
    resetPasswordLink: 'Reset password'
  },

  // Dashboard
  dashboard: {
    welcome: 'Welcome, {name}!',
    welcomeDefault: 'Welcome, User!',
    subtitle: "Here's an overview of your energy account",
    currentBalance: 'Current Balance',
    activeContracts: 'Active Contracts',
    expiringContracts: '{count} expiring soon',
    allContractsCurrent: 'All contracts current',
    monthlyConsumption: "This Month's Consumption",
    consumptionChange: '{percent}% {direction} than last month',
    consumptionMore: 'more',
    consumptionLess: 'less',
    noConsumptionData: 'No data from previous month',
    consumptionBreakdownTitle: 'This month\'s consumption by PPE',
    breakdownPpeCode: 'PPE code',
    breakdownCustomer: 'Customer',
    breakdownConsumption: 'Consumption',
    breakdownChange: '% MoM',
    openInvoices: 'Open Invoices',
    overdueInvoices: '{count} overdue',
    noOverdueInvoices: 'No overdue invoices',
    balanceOutsideSelfService: 'Part of your balance relates to documents not available in the portal — please contact us',
    newIssue: 'New Issue',
    linkCustomerAccount: 'Link customer account',
    reportIssue: 'Report issue',
    recentInvoices: 'Recent Invoices',
    recentContracts: 'Recent Contracts',
    recentIssues: 'Recent Active Issues',
    activeTasks: 'Active Tasks',
    viewAll: 'View all',
    noActiveIssues: 'No active issues',
    allMattersResolved: 'All matters have been resolved',
    loadFailed: 'Failed to load dashboard data'
  },

  // Invoices
  invoices: {
    title: 'Invoices',
    subtitle: 'Browse and manage your invoices',
    invoiceNumber: 'Invoice Number',
    customer: 'Customer',
    issueDate: 'Issue Date',
    amount: 'Amount',
    overpaymentTooltip: 'Overpayment amount',
    paymentDeadline: 'Payment Deadline',
    status: 'Status',
    period: 'Period',
    consumption: 'Consumption',
    dateRange: 'Date Range',
    searchPlaceholder: 'Invoice number...',
    allCustomers: 'All customers',
    customerOptionNip: '{name} (Tax ID {nip})',
    customerOptionNumber: '{name} (customer no. {number})',
    allStatuses: 'All',
    noInvoices: 'No invoices',
    loadFailed: 'Failed to load invoices',
    downloadSuccess: 'Invoice downloaded successfully',
    downloadFailed: 'Failed to download invoice PDF',
    showingResults: 'Showing {first} to {last} of {total} invoices',
    statuses: {
      paid: 'Paid',
      pending: 'Pending',
      unpaid: 'Unpaid',
      overdue: 'Overdue',
      partiallyPaid: 'Partially Paid',
      cancelled: 'Cancelled'
    },
    paymentMethod: {
      transfer: 'Bank transfer',
      compensation: 'Compensation',
      payment: 'Payment'
    },
    lineItems: {
      title: 'Items',
      description: 'Description',
      quantity: 'Quantity',
      unitPrice: 'Unit price',
      value: 'Value',
      empty: 'No items'
    },
    detail: {
      loadFailed: 'Failed to load invoice details',
      title: 'Invoice details',
      issuedOn: 'Issued: {date}',
      billingPeriod: 'Billing period',
      paymentHistory: 'Payment history',
      summary: 'Summary',
      netAmount: 'Net amount',
      vat: 'VAT ({rate}%)',
      totalDue: 'Total due',
      paidAmount: 'Paid',
      remainingAmount: 'Remaining to pay',
      settledAmount: 'Settled',
      outstandingAmount: 'Remaining to settle',
      taxId: 'Tax ID',
      contract: 'Contract'
    }
  },

  // Contracts
  contracts: {
    title: 'Contracts',
    subtitle: 'Browse and manage your energy contracts',
    contractNumber: 'Contract Number',
    customer: 'Customer',
    dateFrom: 'Start Date',
    dateTo: 'End Date',
    status: 'Status',
    searchPlaceholder: 'Contract number...',
    allCustomers: 'All customers',
    allStatuses: 'All',
    noContracts: 'No contracts',
    loadFailed: 'Failed to load contracts',
    daysUntilExpiration: '{days} days until expiration',
    statuses: {
      active: 'Active',
      expiring: 'Expiring',
      expired: 'Expired',
      pending: 'Pending',
      cancelled: 'Cancelled'
    },
    detail: {
      consumptionPoints: 'Consumption points',
      address: 'Address',
      tariffGroup: 'Tariff group',
      contractedPower: 'Contracted power'
    }
  },

  // Issues
  issues: {
    schedule: {
      before: 'Schedule — before correction',
      after: 'Schedule — after correction',
      beforeDate: 'Erroneous modification date',
      afterDate: 'Correct modification date',
      selectPpeAndDate: 'Select a PPE and a date to load the schedule.',
    },
    title: 'My Issues',
    subtitle: 'History and status of your issues',
    newIssue: 'New Issue',
    createFirst: 'Create your first issue',
    noIssues: 'No issues',
    noIssuesDescription: "You don't have any issues yet",
    searchPlaceholder: 'Search issues...',
    allStatuses: 'All',
    allCustomers: 'All customers',
    daysUntilDeadline: '{days} days until deadline',
    addReply: 'Add reply',
    replyPlaceholder: 'Write a reply...',
    loadFailed: 'Failed to load issues',
    reopenedToast: 'Reply added. The issue has been reopened.',
    commentAddedToast: 'Comment added',
    commentFailedToast: 'Failed to add comment',
    finishedBanner: {
      title: 'The issue has been finished',
      deadlineHint: 'You can still add a comment for {deadline}. After that the issue will be permanently closed.',
      reopenHint: 'Adding a comment will reopen the issue.'
    },
    canceledBanner: {
      title: 'You have canceled this issue',
      deadlineHint: 'You can still add a comment for {deadline}. After that the issue will be permanently closed.',
      reopenHint: 'Adding a comment will reopen the issue.'
    },
    cancel: {
      button: 'Cancel issue',
      dialogTitle: 'Cancel issue',
      dialogQuestion: 'Are you sure you want to cancel this issue?',
      dialogHint: 'After canceling you can still add comments for 3 days. You can also create a new issue at any time.',
      dialogCancel: 'No, go back',
      dialogConfirm: 'Yes, cancel issue',
      toastSuccess: 'The issue has been canceled',
      toastError: 'Failed to cancel the issue'
    },
    statuses: {
      new: 'New',
      inProgress: 'In Progress',
      reopened: 'Reopened',
      waiting: 'Waiting for Customer',
      waitingThirdParty: 'Waiting for Distribution Response',
      completed: 'Completed',
      canceled: 'Canceled',
      archived: 'Archived',
      deferred: 'Deferred'
    },
    fields: {
      document_number: 'Document number',
      ppe_number: 'PPE number',
      new_reading_cycle: 'New reading cycle',
      target_tariff: 'Target tariff',
      reported_to_osd: 'Has the change been reported to OSD?',
      report_to_osd: 'Report the change to OSD on behalf of the Customer?',
      effective_date_type: 'Change effective date',
      first_available_date: 'First available date',
      other_date: 'Other date',
      current_power: 'Current contractual power',
      target_power: 'Target contractual power',
      connection_power_change: 'Does connection power change?',
      connection_power_warning: 'Connection power change can be done by the Customer directly at OSD.',
      block_connection_power_change: 'Connection power change can be done by the Customer directly at OSD.',
      is_new_connection: 'Is the new PPE a new connection?',
      osd: 'Which OSD?',
      current_seller: 'Who is the current seller?',
      termination_period: 'What is the termination period?',
      assignee_data: 'Assignee data',
      assignment_start_date: 'Assignment start date',
      contract_number: 'Contract number',
      extension_period: 'Extension period',
      installation_power: 'Installation power',
      energy_type: 'Energy type',
      energy_type_full: 'Full amount',
      energy_type_surplus: 'Surplus',
      ppe_numbers: 'PPE numbers',
      period_start: 'Period from',
      period_end: 'Period to',
      new_contact: 'New phone number / email',
      keep_old_contact: 'Keep previous contact?',
      invoice_numbers: 'Invoice numbers',
      meter_reading: 'Meter reading',
      not_nots_number: 'NOT/NOTS number',
      summons_number: 'Summons number',
      summons_date: 'Summons date',
      compensation_number: 'Compensation / statement number',
      penalty_number: 'Contractual penalty number',
      additional_info: 'Description',
      opis_zgloszenia: 'Issue description',
      searchPlaceholder: 'Search...',
      yes: 'Yes',
      no: 'No',
      assignee_name: 'Assignee name',
      assignee_nip: 'Assignee tax ID',
      assignee_address: 'Primary address',
      assignee_correspondence_address: 'Correspondence address',
      assignee_contact: 'Contact details',
      bank_name: 'Bank name',
      bank_account: 'Bank account number',
      annual_surplus_volume_mwh: 'Estimated annual surplus volume',
      keep_previous_contact: 'Keep previous phone number/email for contact?',
      selectAll: 'All',
      loadingOptions: 'Loading options...',
      requiredField: 'This field is required',
      osdAutoFillPlaceholder: 'OSD will be set after selecting PPE',
      osdAutoFillLoading: 'Reading OSD from PPE...',
      osdAutoFillErrorSummary: 'OSD error',
      osdAutoFillError: 'Could not read OSD — please contact support.',
      osdAutoFillPpeNotFound: 'PPE with this code was not found. Check the value.',
      osdAutoFillMissing: 'Enter a PPE number so the system can fill in OSD. The request cannot be submitted without OSD.',
      osdAutoFillFailedPlaceholder: 'Select OSD manually'
    },
    info: {
      overpayment_scan: 'Please attach the overpayment refund request as a scan.',
      correction_note_scan: 'Please attach the correction note as a scan.',
      termination_signature: 'Please attach the termination: electronically with qualified signature or original to company HQ — otherwise termination is invalid.',
      assignment_osd_process: 'After reporting the ownership change to OSD, a verification process begins (21 days–1.5 months). The operator will set the date from which invoices are issued to the new recipient.',
      new_connection_docs: 'Please attach the ownership deed and documents required by OSD.',
      existing_connection_docs: 'Please attach the latest distribution invoices and at least one sales invoice.',
      required_attachments: 'Required attachments',
      property_right_document: 'Please attach a document confirming property rights.',
      osd_reading_cycles: 'Available billing cycles by DSO',
      wniosek_zwrot_nadplaty: 'Please attach the overpayment refund request as a scan.',
      wniosek_cesja: 'After reporting the ownership change to the Distribution System Operator (DSO), a verification process begins (21 days–1.5 months). The operator will set the date from which invoices are issued to the new recipient.\n\nPlease attach a document confirming property rights.',
      wypowiedzenie_umowy: 'Please attach the termination: electronically with qualified signature or original to company HQ — otherwise termination is invalid.',
      nota_korygujaca: 'Please attach the correction note as a scan.',
      wniosek_zmiana_cyklu_odczytowego: 'Available billing cycles by DSO:\n• Energa: 1m, 2m, 6m, 12m\n• Tauron: 1m, 2m, 6m, 12m\n• Stoen: 1m, 6m, 12m\n• Enea: 1m, 2m, 6m, 12m\n• PGE: 1m, 2m, 6m',
      wniosek_dodanie_ppe_when_true: 'Please attach the ownership deed and documents required by DSO.',
      wniosek_dodanie_ppe_when_false: 'Please attach the latest distribution invoices and at least one sales invoice.',
      wniosek_dodanie_ppe_osd_enea: 'For ENEA, please attach: technical data card with connection conditions, connection agreement.',
      wniosek_dodanie_ppe_osd_energa: 'For ENERGA, please attach: declaration of connection completion.',
      wniosek_dodanie_ppe_osd_pge: 'For PGE, please attach: confirmation of distribution service availability and technical parameters specification.',
      wniosek_dodanie_ppe_osd_tauron: 'For TAURON, please attach: connection completion certificate, technical data card, installation readiness notice.',
      wniosek_dodanie_ppe_osd_innogy: 'For INNOGY, please attach: technical data of the completed connection, installation readiness, connection agreement.',
      wniosek_dodanie_ppe_osd_stoen: 'For STOEN, please attach: technical data of the completed connection, installation readiness, connection agreement.'
    },
    errors: {
      formDataInvalidSummary: 'Form error',
      formDataInvalid: 'Invalid form data — please refresh the page and try again'
    }
  },

  // New Issue
  newIssue: {
    title: 'New Issue',
    subtitle: 'Report an issue to customer service',
    back: 'Back',
    customer: 'Customer',
    customerPlaceholder: 'Select customer',
    category: 'Category',
    categoryPlaceholder: 'Select a category',
    subcategory: 'Subcategory',
    subcategoryPlaceholder: 'Select a subcategory',
    selectCategoryFirst: 'Select a category first',
    issueTitle: 'Issue Title',
    titlePlaceholder: 'Short description of the problem...',
    description: 'Description',
    descriptionPlaceholder: 'Detailed description of the problem, circumstances, expectations...',
    descriptionHint: 'Provide as many details as possible to speed up resolution.',
    submit: 'Submit Issue',
    cancel: 'Cancel',
    submitting: 'Submitting...',
    submitSuccess: 'Issue created successfully. Redirecting...',
    submitFailed: 'Failed to create issue. Please try again.',
    attachments: 'Attachments',
    addMoreFiles: 'Add more files',
    formFields: 'Form fields',
    validation: {
      customerRequired: 'Select a customer',
      categoryRequired: 'Please select an issue category',
      subcategoryRequired: 'Please select an issue subcategory',
      titleRequired: 'Enter issue title',
      titleMinLength: 'Title must be at least 5 characters',
      descriptionRequired: 'Enter issue description',
      descriptionMinLength: 'Description must be at least 20 characters',
      dynamicFieldRequired: 'Field "{field}" is required',
      numericRequired: 'Please enter a number',
      minValue: 'Value cannot be less than {min}'
    },
    help: {
      title: 'How to submit an issue?',
      step1: '1. Select a customer - if you have access to multiple accounts, select which one the issue relates to.',
      step2: '2. Please select the appropriate category and subcategory to help us identify the issue faster and resolve it sooner.',
      step3: '3. Describe in detail - provide all relevant information: document numbers, dates, circumstances.',
      footer: 'After submitting, you will receive a confirmation and our team will handle the matter within 14 days.'
    }
  },

  // Meter Reading
  meterReading: {
    title: 'Submit meter reading',
    submit: 'Submit reading'
  },

  // Navigation (additional)
  navigation: {
    newIssue: 'Submit issue',
    meterReading: 'Submit meter reading'
  },

  // Customers
  customers: {
    title: 'Customers',
    subtitle: 'Manage your linked customer accounts',
    customerName: 'Customer',
    customerNumber: 'Customer Number',
    nipPesel: 'Tax ID/Personal ID',
    linkedAt: 'Linked Date',
    searchPlaceholder: 'Search customer...',
    searchHint: 'Name, customer number or Tax ID',
    ppeSearchPlaceholder: 'Search point...',
    ppeSearchHint: 'PPE code, address or tariff',
    noCustomers: 'No linked customer accounts'
  },

  // Consumption Points
  consumptionPoints: {
    title: 'Consumption and Generation Points',
    subtitle: 'Manage your energy consumption and generation points',
    ppeCode: 'PPE Code',
    noCode: 'No code',
    customer: 'Customer',
    category: 'Category',
    tariff: 'Tariff',
    contract: 'Contract',
    contractActive: 'Active',
    contractInactive: 'Inactive',
    searchPlaceholder: 'Search point...',
    searchHint: 'PPE code, address, tariff or customer',
    allCategories: 'All',
    allCustomers: 'All customers',
    noConsumptionPoints: 'No consumption and generation points',
    loadFailed: 'Failed to load consumption points',
    invoicesEmpty: 'No invoices for this point',
    categories: {
      consumption: 'Consumption',
      generation: 'Generation'
    }
  },

  // Generation Scheduling
  scheduling: {
    contractedPower: 'Contracted power',
    generationSource: 'Generation source',
    unitKw: 'kW',
    title: 'Generation Scheduling',
    subtitle: 'Manage energy generation schedules for generation points',
    listTitle: 'Generation Scheduling',
    listSubtitle: 'Manage energy generation schedules for generation points',
    detailTitle: 'Generation Schedule',
    selectPoint: 'Select generation point',
    pointPlaceholder: 'Select point...',
    selectDate: 'Select date',
    scheduleDate: 'Schedule date',
    schedule: 'Schedule',
    schedule24h: '24-hour schedule',
    hour: 'Hour',
    valueKwh: 'Value (kWh)',
    systemProposed: 'System (kWh)',
    effectiveValue: 'Effective (kWh)',
    source: 'Source',
    sourceSystem: 'System',
    sourceUser: 'User',
    sourceSystemUser: 'System+User',
    total: 'Total',
    totalEdited: 'Total edited',
    totalSystem: 'Total system',
    totalEffective: 'Total effective',
    userHours: 'User hours',
    editedNow: 'Edited now',
    deadline: 'Deadline',
    deadlinePassed: 'Deadline passed',
    deadlineInfo: 'Submission deadline: {time}',
    deadlineNotice: 'Schedule submission deadline: {time}',
    saveSchedule: 'Save',
    downloadExcel: 'Download',
    uploadFromFile: 'Upload from file',
    restoreSystem: 'Restore system values',
    noPoints: 'No generation points',
    loadFailed: 'Failed to load schedule',
    saveSuccess: 'Schedule saved successfully',
    saveFailed: 'Failed to save schedule',
    deadlinePassedError: 'Schedule submission deadline has passed',
    noChanges: 'No changes to save',
    hoursModified: '{count} hours',
    // List page
    generationPoint: 'Generation point',
    noPpeCode: 'No PPE code',
    customer: 'Customer',
    allCustomers: 'All customers',
    systemTotal: 'System total',
    effectiveTotal: 'Effective total',
    editSchedule: 'Edit/view schedule',
    refresh: 'Refresh',
    showingPoints: 'Showing {first} to {last} of {totalRecords} points',
    // Source/status labels
    sources: {
      none: 'No data',
      system: 'System',
      partial: 'System+User',
      full: 'User'
    },
    // Upload dialog
    uploadDialog: {
      title: 'Upload schedule from Excel file',
      description: 'You can download a template and modify it, or download the current schedule, modify it and import it here.',
      downloadTemplate: 'download template',
      warning: 'If the file contains a date or PPE code, they must match the currently selected schedule.',
      selectFile: 'Select Excel file',
      upload: 'Upload',
      uploadSuccess: 'Loaded {count} hourly values. Click "Save" to save changes.',
      uploadFailed: 'Failed to read Excel file. Check if the file is in correct format.',
      noData: 'No hourly data found in file',
      dateMismatch: 'Date in file ({fileDate}) does not match selected date ({selectedDate})',
      ppeMismatch: 'PPE code in file ({filePpe}) does not match current ({currentPpe})',
      invalidStatuses: 'Skipped unknown or disallowed statuses for hours: {hours}',
      invalidStatusReasons: {
        notAllowedAfterDeadline: 'not allowed after the deadline'
      }
    },
    // Status column
    status: 'Status',
    statusOptions: {
      none: 'None',
      other: 'Other',
      pseRedispatch: 'PSE Redispatch',
      installationFailure: 'Installation failure',
      powerReduction: 'Power reduction',
      plannedMaintenance: 'Planned maintenance',
      plannedShutdown: 'Planned shutdown'
    },
    setStatusForAll: 'Set status for all hours',
    bulkStatusDescription: 'Selected status will be applied to all 24 hours in the schedule.',
    selectStatus: 'Select status',
    apply: 'Apply',
    // Deadline indicator
    deadlineIndicator: {
      canEdit: 'You can edit the schedule until',
      cannotEdit: 'Edit deadline has passed',
      statusOnly: 'After deadline you can only change status (PSE Redispatch, Installation failure)'
    },
    // Other
    modified: 'Modified',
    lastChange: 'Last change',
    back: 'Back',
    systemApplied: 'System values have been applied to all hours',
    templateDownloaded: 'Template downloaded',
    templateDownloadFailed: 'Failed to download template',
    excelDownloaded: 'Excel file downloaded',
    excelDownloadFailed: 'Failed to download Excel file',
    editingUnavailable: 'Schedule editing is unavailable',
    uploadUnavailable: 'Schedule upload is unavailable - deadline passed',
    tolerance: {
      exceeded: 'Value exceeds tolerance limit ({max} kWh)',
      importWarning: '{count} values exceed the tolerance limit ({max} kWh/h)'
    }
  },

  // Account Matching
  accountMatching: {
    title: 'Link Customer Account',
    subtitle: 'Link your customer account to access invoices, contracts and consumption points',
    verification: 'Account Verification',
    modeNip: 'Verification by NIP',
    modeNipDescription: 'For companies and customers with a NIP',
    modePesel: 'Verification by PESEL',
    modePeselDescription: 'For individual customers without a NIP',
    nip: 'Tax ID (NIP)',
    nipPlaceholder: '0000000000',
    nipHint: '10-digit tax identification number',
    pesel: 'PESEL',
    peselPlaceholder: '00000000000',
    peselHint: '11-digit Polish PESEL number from your contract',
    peselFormatError: 'The PESEL number must be 11 digits with a valid checksum.',
    identifierNone: '—',
    phone: 'Phone number',
    phonePlaceholder: '+48 000 000 000',
    phoneHint: '+48 is pre-filled by default — you can change it if your number is from outside Poland. Format: +<country code><digits>',
    phoneFormatError: 'The number must start with „+" and a country code (e.g. +48 for Poland).',
    customerNumber: 'Customer number',
    customerNumberPlaceholder: '123456',
    customerNumberHint: 'Number from contract or invoice',
    submit: 'Link Account',
    submitting: 'Verifying...',
    success: 'Account linked successfully!',
    failed: 'Failed to link account. Please check your data.',
    notFound: 'No account found with the provided data.',
    alreadyLinked: 'This account is already linked to your profile.',
    rateLimited: 'Too many attempts. Please try again later.',
    attemptsRemaining: 'Attempts remaining: {count}',
    noAttemptsLeft: 'You have used the attempt limit. Please try again in {minutes} min. The data you enter must match your contract — also check that you picked the right verification mode (NIP or PESEL). More information in the user manual:',
    noAttemptsLeftUnknown: 'That was your last attempt — the next one will be blocked. The data you enter must match your contract — also check that you picked the right verification mode (NIP or PESEL). More information in the user manual:',
    instructions: 'To link your account, provide verification data from an invoice or contract.',
    linkedAccounts: 'Linked Accounts',
    accountsCount: '{count} account | {count} accounts',
    noLinkedAccounts: "You don't have any linked accounts yet",
    useFormAbove: 'Use the form above to link your customer account',
    active: 'Active',
    linked: 'Linked',
    detach: 'Detach',
    detachConfirm: 'Are you sure you want to detach this account?',
    detachFailed: 'Failed to detach account.'
  },

  // Profile
  profile: {
    title: 'User Profile',
    subtitle: 'Client portal',
    personalInfo: 'Account Information',
    email: 'Email address',
    userId: 'User ID',
    linkedCustomers: 'Linked customers',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    changePassword: 'Change Password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    saveChanges: 'Save Changes',
    updateSuccess: 'Profile updated successfully',
    updateFailed: 'Failed to update profile',
    passwordChangeSuccess: 'Password changed successfully',
    passwordChangeFailed: 'Failed to change password',
    editComingSoon: 'Profile editing features will be available soon.',
    deleteAccount: 'Delete account',
    deleteAccountTitle: 'Delete account',
    deleteAccountWarning: 'This action is irreversible. All your personal data will be permanently deleted and access to your account will be blocked.',
    confirmDeletion: 'Confirm deletion',
    deleteAccountSuccess: 'Account has been deleted.',
    deleteAccountError: 'Failed to delete account. Check your password and try again.',
    enterPasswordToConfirm: 'Enter your current password to confirm',
    linkedAccountsWarning: 'Your links to {count} customer accounts will be deactivated.',
    accountDeletedBanner: 'Account has been successfully deleted and anonymized.',
    adminCannotDelete: 'Admin accounts cannot be self-deleted. Contact support.',
    tooManyAttempts: 'Too many attempts. Please try again later.'
  },

  // Operator Management
  operatorManagement: {
    title: 'Operator Management',
    subtitle: 'Assign and revoke operator access to production facilities',
    assign: {
      title: 'Assign Operator',
      description: 'Grant a user operator access to a specific production facility.',
      userEmail: 'User email',
      userEmailPlaceholder: "operator{'@'}example.com",
      customerNumber: 'Customer number',
      customerNumberPlaceholder: 'e.g. 12345',
      ppeCode: 'PPE code',
      ppeCodePlaceholder: 'e.g. PPE-001W',
      ppeCodeHint: 'PPE code ending in W (production facility)',
      ppeSelectCustomerFirst: 'Select a customer first',
      submit: 'Assign operator',
      success: 'User has been assigned as operator.',
      failed: 'Failed to assign operator.',
      errorUserNotFound: 'You can add only registered users.',
      errorInvalidRole: 'User cannot be assigned as operator.',
      fullAccessConfirmHeader: 'Confirm Full Access assignment',
      fullAccessConfirmMessage: 'This user has the Full Access role. They will be granted full access to this customer. Do you want to continue?'
    },
    operators: {
      title: 'Operators list',
      filterPlaceholder: 'Search operator, customer, PPE...',
      operator: 'Operator',
      customer: 'Customer',
      ppe: 'Facility (PPE)',
      role: 'Role',
      roleOperator: 'Operator',
      roleFullAccess: 'Full Access',
      noOperators: 'No operators assigned',
      loadFailed: 'Failed to load operators list',
      removeTooltip: 'Revoke access',
      removeHeader: 'Confirm access revocation',
      removeConfirm: 'Are you sure you want to revoke operator access for {email} to customer {customer}?',
      removeAccept: 'Revoke access',
      removeFailed: 'Failed to revoke operator access.',
      showingResults: 'Showing {first} to {last} of {totalRecords} operators'
    },
    observe: {
      title: 'Assign observer',
      description: 'Grant a user observer access to a specific PPE. The same user cannot be assigned to the same PPE twice.',
      userEmail: 'User email',
      userEmailPlaceholder: "observer{'@'}example.com",
      customerNumber: 'Customer number',
      customerNumberPlaceholder: 'e.g. 12345',
      ppeCode: 'PPE code',
      ppeCodePlaceholder: 'e.g. PPE-001',
      ppeCodeHint: 'Any consumption or generation point (not limited to W suffix)',
      ppeSelectCustomerFirst: 'Select a customer first',
      submit: 'Assign observer',
      success: 'User has been assigned as observer.',
      failed: 'Failed to assign observer.'
    },
    observers: {
      title: 'Observers list',
      filterPlaceholder: 'Search observer, customer, PPE...',
      observer: 'Observer',
      customer: 'Customer',
      ppe: 'PPE',
      noObservers: 'No observers assigned',
      loadFailed: 'Failed to load observers list',
      removeTooltip: 'Revoke observer access',
      removeHeader: 'Confirm access revocation',
      removeConfirm: 'Are you sure you want to revoke observer access for {email} to PPE {ppe}?',
      removeAccept: 'Revoke access',
      removeFailed: 'Failed to revoke observer access.',
      showingResults: 'Showing {first} to {last} of {totalRecords} observers'
    }
  },

  // Impersonation
  impersonate: {
    startError: 'Failed to start impersonation — session restored',
    banner: {
      acting_as: 'Acting as {email}',
      stop: 'Stop impersonation'
    },
    panel: {
      title: 'User impersonation',
      search: 'Search user (email, name)...',
      email: 'Email',
      role: 'Role',
      customers: 'Linked customers',
      action: 'Impersonate',
      confirm_title: 'Confirm impersonation',
      confirm_message: 'Are you sure you want to act as {email}?'
    },
    error: {
      forbidden: 'Impersonation not permitted',
      admin_target: 'Cannot impersonate an administrator'
    }
  },

  // Deletion warning
  deletion_warning: {
    banner: {
      message: 'Your account will be deleted on {date} due to: {reason}. Log in regularly to prevent deletion.'
    },
    reasons: {
      expired_contract: 'contract expiration',
      unverified_account: 'unverified account'
    }
  },

  // Errors
  errors: {
    general: 'An error occurred',
    networkError: 'Server connection error',
    unauthorized: 'Session expired. Please login again.',
    forbidden: 'Access denied to this resource',
    notFound: 'Resource not found',
    serverError: 'Server error. Please try again later.'
  },

  // 404 Page
  notFound: {
    title: 'Page Not Found',
    message: 'Sorry, the page you are looking for does not exist.',
    backHome: 'Back to Home'
  },

  // Payment
  payment: {
    success: {
      title: 'Payment accepted',
      message: 'Thank you for your payment.',
      sync_info: 'Invoice status will update within a few minutes.',
    },
    processing: {
      title: 'Payment in progress',
      message: 'We received your payment order. The invoice will be marked as paid once your bank confirms it — usually within a few minutes.',
    },
    error: {
      title: 'Something went wrong',
      message: 'Payment could not be processed. Try again or contact support.',
      contact: 'Contact support: {email}',
      contact_with_phone: 'Contact support: {email}, phone {phone}',
      invoice_already_paid: 'Invoice already paid.',
      customer_email_missing: 'Customer email missing. Contact support.',
      access_denied: 'Access denied.',
      gateway_unavailable: 'Payment gateway unavailable. Try again.',
      rate_limit_exceeded: 'Too many attempts. Try again in a few minutes.',
      invoice_unpaid: 'The invoice remains unpaid.',
    },
    neutral: {
      title: 'Payment status',
      message: 'Unable to confirm payment status. Check your invoices.',
    },
    invoice: 'Invoice',
    back_to_invoice: 'Back to invoice',
    view_invoices: 'View invoices',
    login: 'Log in',
    loading: 'Checking payment status...',
    pay_amount: 'Pay {amount}',
    redirecting: 'Redirecting to payment gateway...',
    invoice_paid: 'Invoice paid',
    pay_page: {
      title: 'Invoice payment',
      invoice: 'Invoice',
      amount_due: 'Amount due',
      due_date: 'Due date',
      customer: 'Customer',
      validity_info: 'After clicking "Pay" you will be redirected to the payment gateway. You have 24 hours to complete the payment.',
      already_paid: 'Invoice has been paid.',
      token_expired: 'Link expired. Contact support at {email} for a new link.',
      token_expired_with_phone: 'Link expired. Contact support at {phone} or {email} for a new link.',
      invalid_token: 'Invalid payment link. Contact support at {email}.',
      invalid_token_with_phone: 'Invalid payment link. Contact support at {phone} or {email}.',
      missing_token: 'Invalid payment link. Contact support at {email}.',
      missing_token_with_phone: 'Invalid payment link. Contact support at {phone} or {email}.',
      invoice_not_found: 'Invoice not found.',
      gateway_error: 'Payment gateway temporarily unavailable. Try again.',
      invoice_already_paid: 'Invoice already paid.',
      rate_limit_exceeded: 'Too many attempts. Try again in a few minutes.',
      payment_in_progress: 'Payment is being processed. The invoice will be marked as paid once the bank confirms it.',
      connection_error: 'Cannot reach the server. Check your internet connection and try again.',
    },
  }
}
